import { createTheme, alpha } from '@mui/material/styles';

const defaultTheme = createTheme();

const customShadows = [...defaultTheme.shadows];

export const brand = {
  50: 'hsl(250, 100%, 97%)',
  100: 'hsl(250, 95%, 94%)',
  200: 'hsl(250, 90%, 85%)',
  300: 'hsl(250, 85%, 72%)',
  400: 'hsl(250, 75%, 60%)',
  500: 'hsl(250, 70%, 52%)',
  600: 'hsl(250, 75%, 48%)',
  700: 'hsl(250, 80%, 42%)',
  800: 'hsl(250, 85%, 35%)',
  900: 'hsl(250, 90%, 28%)',
};

export const gray = {
  50: 'hsl(220, 35%, 97%)',
  100: 'hsl(220, 30%, 94%)',
  200: 'hsl(220, 20%, 88%)',
  300: 'hsl(220, 20%, 80%)',
  400: 'hsl(220, 20%, 65%)',
  500: 'hsl(220, 20%, 42%)',
  600: 'hsl(220, 20%, 35%)',
  700: 'hsl(220, 20%, 25%)',
  800: 'hsl(220, 30%, 6%)',
  900: 'hsl(220, 35%, 3%)',
};

export const chartColors = [
  '#3B82F6', '#F59E0B', '#8B5CF6', '#10B981', '#6B7280', '#61223f',
  '#b11b1bff', '#f7077fff', '#14B8A6', '#F97316', '#6366F1', '#84CC16', '#fd9ab4ff'
];

export const mainGradientLight = 'linear-gradient(135deg, #F0F4FF 0%, #E0E7FF 50%, #EDE9FE 100%)';
export const mainGradientDark = 'linear-gradient(135deg, #0F172A 0%, #1E293B 50%, #334155 100%)';
export const outlineGradient = 'linear-gradient(90deg, #4A90E2, #9013FE)';

export const sidebar = {
  light: {
    bg: 'linear-gradient(180deg, rgba(248,249,255,0.8) 0%, rgba(240,244,255,0.6) 100%)',
    logoGradient: 'linear-gradient(135deg, hsl(250, 75%, 60%) 0%, hsl(210, 70%, 55%) 100%)',
    textGradient: 'linear-gradient(135deg, rgba(90, 41, 210, 1) 0%, rgba(14, 165, 233, 0.9) 100%)',
    accent: '#6b5ad0',
  },
  dark: {
    bg: 'linear-gradient(180deg, rgba(9,12,20,0.86) 0%, rgba(18,25,38,0.86) 100%)',
    logoGradient: 'linear-gradient(135deg, rgba(140,116,255,0.95) 0%, rgba(50,140,255,0.95) 100%)',
    textGradient: 'linear-gradient(135deg, rgba(170,140,255,0.92) 0%, rgba(99,179,255,0.9) 100%)',
    accent: '#a798ff',
  },
};

export const cardBg = {
  light: 'rgba(255, 255, 255, 0.98)',
  dark: 'rgba(30, 41, 59, 0.95)'
};

export const glass = {
  light: {
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(24px) saturate(180%)',
    border: '1px solid rgba(255, 255, 255, 0.8)',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.08), 0 2px 8px 0 rgba(31, 38, 135, 0.04)',
    borderRadius: '16px',
  },
  dark: {
    background: 'rgba(30, 41, 59, 0.85)',
    backdropFilter: 'blur(24px) saturate(180%)',
    border: '1px solid rgba(148, 163, 184, 0.2)',
    boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.3), 0 2px 8px 0 rgba(0, 0, 0, 0.2)',
    borderRadius: '16px',
  }
};

export const statusColors = {
  light: {
    todo: { main: '#8F6B36', light: '#B58855', dark: '#6f4f28', contrast: '#FFFFFF', bg: '#FFF8F1' },
    inprogress: { main: '#368F45', light: '#57b86a', dark: '#246832', contrast: '#FFFFFF', bg: '#F0FFF5' },
    inreview: { main: '#3F3688', light: '#6b5ad0', dark: '#2b235b', contrast: '#FFFFFF', bg: '#F3F1FF' },
    completed: { main: '#8F3658', light: '#b65376', dark: '#61223f', contrast: '#FFFFFF', bg: '#FFF2F7' },
    closed: { main: '#374151', light: '#55606a', dark: '#0f1724', contrast: '#FFFFFF', bg: '#F4F6F8' },
  },
  dark: {
    todo: { main: '#B58855', light: '#e6cea9', dark: '#8f6b36', contrast: '#0f1724', bg: '#3b2d1a' },
    inprogress: { main: '#57b86a', light: '#8de299', dark: '#2b6b36', contrast: '#0f1724', bg: '#0b2b18' },
    inreview: { main: '#6b5ad0', light: '#a798ff', dark: '#2d2352', contrast: '#0f1724', bg: '#2b224b' },
    completed: { main: '#b65376', light: '#ff98b3', dark: '#6a2340', contrast: '#0f1724', bg: '#3a1a2a' },
    closed: { main: '#55606a', light: '#8f9aa4', dark: '#2c3940', contrast: '#0f1724', bg: '#0f1724' },
  }
};

export const green = {
  50: 'hsl(145, 80%, 97%)',
  100: 'hsl(145, 75%, 92%)',
  200: 'hsl(145, 70%, 85%)',
  300: 'hsl(145, 65%, 72%)',
  400: 'hsl(145, 60%, 55%)',
  500: 'hsl(145, 65%, 42%)',
  600: 'hsl(145, 70%, 35%)',
  700: 'hsl(145, 75%, 28%)',
  800: 'hsl(145, 80%, 22%)',
  900: 'hsl(145, 85%, 16%)',
};

export const orange = {
  50: 'hsl(38, 100%, 97%)',
  100: 'hsl(38, 95%, 92%)',
  200: 'hsl(38, 90%, 82%)',
  300: 'hsl(38, 85%, 68%)',
  400: 'hsl(38, 80%, 55%)',
  500: 'hsl(38, 85%, 48%)',
  600: 'hsl(38, 90%, 42%)',
  700: 'hsl(38, 92%, 35%)',
  800: 'hsl(38, 94%, 28%)',
  900: 'hsl(38, 96%, 22%)',
};

export const red = {
  50: 'hsl(4, 100%, 97%)',
  100: 'hsl(4, 95%, 92%)',
  200: 'hsl(4, 90%, 82%)',
  300: 'hsl(4, 85%, 68%)',
  400: 'hsl(4, 80%, 58%)',
  500: 'hsl(4, 85%, 50%)',
  600: 'hsl(4, 88%, 45%)',
  700: 'hsl(4, 90%, 38%)',
  800: 'hsl(4, 92%, 30%)',
  900: 'hsl(4, 94%, 24%)',
};

export const getDesignTokens = (mode) => {
  customShadows[1] =
    mode === 'dark'
      ? 'hsla(220, 30%, 5%, 0.7) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.8) 0px 8px 16px -5px'
      : 'hsla(220, 30%, 5%, 0.07) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.07) 0px 8px 16px -5px';

  return {
    palette: {
      mode,
      primary: {
        light: brand[200],
        main: brand[400],
        dark: brand[700],
        contrastText: brand[50],
        ...(mode === 'dark' && {
          contrastText: brand[50],
          light: brand[300],
          main: brand[400],
          dark: brand[700],
        }),
      },
      info: {
        light: brand[100],
        main: brand[300],
        dark: brand[600],
        contrastText: gray[50],
        ...(mode === 'dark' && {
          contrastText: brand[300],
          light: brand[500],
          main: brand[700],
          dark: brand[900],
        }),
      },
      warning: {
        light: orange[300],
        main: orange[400],
        dark: orange[800],
        ...(mode === 'dark' && {
          light: orange[400],
          main: orange[500],
          dark: orange[700],
        }),
      },
      error: {
        light: red[300],
        main: red[400],
        dark: red[800],
        ...(mode === 'dark' && {
          light: red[400],
          main: red[500],
          dark: red[700],
        }),
      },
      success: {
        light: green[300],
        main: green[400],
        dark: green[800],
        ...(mode === 'dark' && {
          light: green[400],
          main: green[500],
          dark: green[700],
        }),
      },
      custom: {
        light: brand[400],
        dark: brand[700],
        ...(mode === 'dark' && {
          light: gray[50],
          dark: gray[50],
        }),
      },
      grey: {
        ...gray,
      },
      divider: mode === 'dark' ? alpha(gray[700], 0.6) : alpha(gray[300], 0.4),
      background: {
        default: 'hsl(0, 0%, 99%)',
        paper: 'hsl(220, 35%, 97%)',
        ...(mode === 'dark' && { default: gray[900], paper: 'hsl(220, 30%, 7%)' }),
      },
      text: {
        primary: gray[800],
        secondary: gray[600],
        warning: orange[400],
        ...(mode === 'dark' && {
          primary: 'hsl(0, 0%, 100%)',
          secondary: gray[400],
        }),
      },
      action: {
        hover: alpha(gray[200], 0.2),
        selected: `${alpha(gray[200], 0.3)}`,
        ...(mode === 'dark' && {
          hover: alpha(gray[600], 0.2),
          selected: alpha(gray[600], 0.3),
        }),
      },
      chartColors,
      mainGradient: mode === 'dark' ? mainGradientDark : mainGradientLight,
      sidebar: mode === 'dark' ? sidebar.dark : sidebar.light,
      cardBg: mode === 'dark' ? cardBg.dark : cardBg.light,
      glass: mode === 'dark' ? glass.dark : glass.light,
      statusColors: mode === 'dark' ? statusColors.dark : statusColors.light,
      outlineGradientColor: outlineGradient,
    },
    typography: {
      fontFamily: 'Inter, sans-serif',
      h1: {
        fontSize: defaultTheme.typography.pxToRem(48),
        fontWeight: 600,
        lineHeight: 1.2,
        letterSpacing: -0.5,
      },
      h2: {
        fontSize: defaultTheme.typography.pxToRem(36),
        fontWeight: 600,
        lineHeight: 1.2,
      },
      h3: {
        fontSize: defaultTheme.typography.pxToRem(30),
        lineHeight: 1.2,
      },
      h4: {
        fontSize: defaultTheme.typography.pxToRem(24),
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h5: {
        fontSize: defaultTheme.typography.pxToRem(20),
        fontWeight: 600,
      },
      h6: {
        fontSize: defaultTheme.typography.pxToRem(18),
        fontWeight: 600,
      },
      subtitle1: {
        fontSize: defaultTheme.typography.pxToRem(18),
      },
      subtitle2: {
        fontSize: defaultTheme.typography.pxToRem(14),
        fontWeight: 500,
      },
      body1: {
        fontSize: defaultTheme.typography.pxToRem(14),
      },
      body2: {
        fontSize: defaultTheme.typography.pxToRem(14),
        fontWeight: 400,
      },
      caption: {
        fontSize: defaultTheme.typography.pxToRem(12),
        fontWeight: 400,
      },
    },
    shape: {
      borderRadius: 8,
    },
    shadows: customShadows,
  };
};

export const colorSchemes = {
  light: {
    palette: {
      primary: {
        light: brand[200],
        main: brand[400],
        dark: brand[700],
        contrastText: brand[50],
      },
      info: {
        light: brand[100],
        main: brand[300],
        dark: brand[600],
        contrastText: gray[50],
      },
      warning: {
        light: orange[300],
        main: orange[400],
        dark: orange[800],
      },
      error: {
        light: red[300],
        main: red[400],
        dark: red[800],
      },
      success: {
        light: green[300],
        main: green[400],
        dark: green[800],
      },
      grey: {
        ...gray,
      },
      divider: alpha(gray[300], 0.4),
      background: {
        default: 'hsl(0, 0%, 99%)',
        paper: 'hsl(220, 35%, 97%)',
      },
      text: {
        primary: gray[800],
        secondary: gray[600],
        warning: orange[400],
      },
      action: {
        hover: alpha(gray[200], 0.2),
        selected: `${alpha(gray[200], 0.3)}`,
      },
      baseShadow:
        'hsla(220, 30%, 5%, 0.07) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.07) 0px 8px 16px -5px',
      statusColors: statusColors.light,
      sidebar: sidebar.light,
      mainGradient: mainGradientLight,
      cardBg: cardBg.light,
      chartColors: chartColors,
      outlineGradientColor: outlineGradient,
      glass: glass.light,
    },
  },
  dark: {
    palette: {
      primary: {
        contrastText: brand[50],
        light: brand[300],
        main: brand[400],
        dark: brand[700],
      },
      info: {
        contrastText: brand[300],
        light: brand[500],
        main: brand[700],
        dark: brand[900],
      },
      warning: {
        light: orange[400],
        main: orange[500],
        dark: orange[700],
      },
      error: {
        light: red[400],
        main: red[500],
        dark: red[700],
      },
      success: {
        light: green[400],
        main: green[500],
        dark: green[700],
      },
      grey: {
        ...gray,
      },
      divider: alpha(gray[700], 0.6),
      background: {
        default: gray[900],
        paper: 'hsl(220, 30%, 7%)',
      },
      text: {
        primary: 'hsl(0, 0%, 100%)',
        secondary: gray[400],
      },
      action: {
        hover: alpha(gray[600], 0.2),
        selected: alpha(gray[600], 0.3),
      },
      baseShadow:
        'hsla(220, 30%, 5%, 0.7) 0px 4px 16px 0px, hsla(220, 25%, 10%, 0.8) 0px 8px 16px -5px',
      statusColors: statusColors.dark,
      sidebar: sidebar.dark,
      mainGradient: mainGradientDark,
      cardBg: cardBg.dark,
      chartColors: chartColors,
      outlineGradientColor: outlineGradient,
      glass: glass.dark,
    },
  },
};

export const typography = {
  fontFamily: 'Inter, sans-serif',
  h1: {
    fontSize: defaultTheme.typography.pxToRem(48),
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: -0.5,
  },
  h2: {
    fontSize: defaultTheme.typography.pxToRem(36),
    fontWeight: 600,
    lineHeight: 1.2,
  },
  h3: {
    fontSize: defaultTheme.typography.pxToRem(30),
    lineHeight: 1.2,
  },
  h4: {
    fontSize: defaultTheme.typography.pxToRem(24),
    fontWeight: 600,
    lineHeight: 1.5,
  },
  h5: {
    fontSize: defaultTheme.typography.pxToRem(20),
    fontWeight: 600,
  },
  h6: {
    fontSize: defaultTheme.typography.pxToRem(18),
    fontWeight: 600,
  },
  subtitle1: {
    fontSize: defaultTheme.typography.pxToRem(18),
  },
  subtitle2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 500,
  },
  body1: {
    fontSize: defaultTheme.typography.pxToRem(14),
  },
  body2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 400,
  },
  caption: {
    fontSize: defaultTheme.typography.pxToRem(12),
    fontWeight: 400,
  },
};

export const shape = {
  borderRadius: 8,
};

const defaultShadows = [
  'none',
  'var(--template-palette-baseShadow)',
  ...defaultTheme.shadows.slice(2),
];

export const shadows = defaultShadows;
